import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["audio"];

  connect() {
    // Turbo Drive builds each visited page in a detached document before
    // swapping it in, and Chrome refuses to load media there ("Media load
    // rejected by URL safety check"). The element keeps that error once it is
    // on the page, so the first step after a redirect -- starting a check-in
    // or a demo -- never spoke its heading, and tapping it did nothing either.
    // Loading again now that the element is live recovers it; autoplay still
    // applies, carried by the click that started the visit.
    if (this.audioTarget.error) {
      this.audioTarget.load();
    }
  }

  play() {
    // Play the audio
    this.audioTarget.play().catch((error) => {
      console.error("Error playing audio:", error);
    });
  }
}
